import axios from 'axios';
import {API_URL_PREFIX, axiosErrorHandler} from "./axios.utils";

const API_URL = API_URL_PREFIX + '/v1/contact';

class ContactService {
    // no header required
    createContact(payload) {
        return axios.post(API_URL, payload).catch(function (error) {
            axiosErrorHandler(error);
        });
    }
}

export default new ContactService();
